"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.PatientDetails = void 0;
var _react = _interopRequireDefault(require("react"));
var _intl = require("@kyruus/intl");
var _moment = _interopRequireDefault(require("moment"));
var _reactPhoneNumberInput = require("react-phone-number-input");
var _styles = require("./styles");
var _messages = _interopRequireDefault(require("../../lib/messages"));
const PatientDetails = _ref => {
  let {
    name,
    dob,
    email,
    phoneNumber,
    insurance,
    notes
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("section", {
    "data-testid": "ReviewAppt__PatientDetails"
  }, /*#__PURE__*/_react.default.createElement(_styles.SectionHeading, null, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.patientDetails)), /*#__PURE__*/_react.default.createElement(_styles.Row, {
    "data-testid": "Row"
  }, /*#__PURE__*/_react.default.createElement(_styles.Label, null, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.patientName)), /*#__PURE__*/_react.default.createElement(_styles.Text, null, name)), /*#__PURE__*/_react.default.createElement(_styles.Row, {
    "data-testid": "Row"
  }, /*#__PURE__*/_react.default.createElement(_styles.Label, null, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.dateOfBirth)), /*#__PURE__*/_react.default.createElement(_styles.Text, null, (0, _moment.default)(dob).format('MM/DD/YYYY'))), /*#__PURE__*/_react.default.createElement(_styles.Row, {
    "data-testid": "Row"
  }, /*#__PURE__*/_react.default.createElement(_styles.Label, null, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.emailAddress)), /*#__PURE__*/_react.default.createElement(_styles.Text, null, email)), /*#__PURE__*/_react.default.createElement(_styles.Row, {
    "data-testid": "Row"
  }, /*#__PURE__*/_react.default.createElement(_styles.Label, null, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.phoneNumber)), /*#__PURE__*/_react.default.createElement(_styles.Text, null, (0, _reactPhoneNumberInput.formatPhoneNumber)(phoneNumber) || phoneNumber)), insurance && /*#__PURE__*/_react.default.createElement(_styles.Row, {
    "data-testid": "Row"
  }, /*#__PURE__*/_react.default.createElement(_styles.Label, null, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.insurance)), /*#__PURE__*/_react.default.createElement(_styles.Text, null, insurance)), /*#__PURE__*/_react.default.createElement(_styles.Row, {
    "data-testid": "Row"
  }, /*#__PURE__*/_react.default.createElement(_styles.Label, null, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.patientNotes)), /*#__PURE__*/_react.default.createElement(_styles.Text, null, notes)));
};
exports.PatientDetails = PatientDetails;
PatientDetails.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "PatientDetails"
};